
















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 'Sort',
  components: {}
})
export default class Sort extends Vue {
  @Prop({
    type: Number,
    default: 1
  }) value!: number

  sortType: 0 | 1 | '' = '' // 1升序 0 降序

  get srotActive (): number {
    return this.value
  }

  set srotActive (newData) {
    this.inputValue(newData)
  }

  @Emit('input')
  inputValue (newData): number {
    return newData
  }

  @Emit('change')
  clickSort (id: number): {id: number; sortType: number} {
    if (id === this.srotActive) {
      if (this.sortType === '' || this.sortType === 0) {
        this.sortType = 1
      } else {
        this.sortType = 0
      }
    } else {
      this.srotActive = id
      this.sortType = 1
    }
    return {
      id,
      sortType: this.sortType
    }
  }
}
